<template>
    <div>
        <img class="componentImage" :src="$loadImage(media_comms_screenshot)">
        <!-- <div class="nav hvh-flex column">
            <button class="button" href="/">Aggregated Dashboard</button>
        </div> -->
    </div>
    <!-- add a fixed button under the tabs to link to aggregated dashboard -->
</template>
<script>
// import media_comms_screenshot from '';

export default {
    // import {},

    props: ['modelData'],

    data() {
        return {
            media_comms_screenshot: require('../../assets/images/actics/aggregated_brand_dashboard_v2.png'),
        }
    }

}

</script>
<style scoped>
.componentImage {
    width: 100%;
    justify-content: left;
    height: 100%;
}

.button {
    background-color: rgba(185, 192, 210, 0.14);
    width: 180px;
    color: #8c9093;
    font-weight: bold;
    letter-spacing: 0.3px;
    padding: 5px 5px;
    border-radius: 5px;
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    text-align: center;
    display: inline-block;
    white-space: nowrap;
    position: fixed;
    top: 380px;
    left: 20px;
    justify-content: center;

}
</style>